import { Action, createReducer, on } from '@ngrx/store';
import { logout, sessionExpired, sessionExpiredConfirmed } from './login.actions';
import { LoginState } from './login.state';

const initialState: LoginState = {
    sessionExpired: false
};

const reducer = createReducer(
    initialState,
    on(sessionExpired, (state) => ({ ...state, sessionExpired: true })),
    on(sessionExpiredConfirmed, (state) => ({ ...state, sessionExpired: false })),
    on(logout, () => ({ ...initialState }))
);

export function loginReducer(state: LoginState | undefined, action: Action): any {
    return reducer(state, action);
}

